var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticStyle:{"margin-top":"20px"},attrs:{"shadow":"never"}},[_c('iframe',{style:(`width: ${_vm.width}; height: ${_vm.height}; border: none`),attrs:{"src":_vm.content}})])
}
var staticRenderFns = []

export { render, staticRenderFns }